import { Button } from 'fronton-react';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useTranslation } from 'react-i18next';
import { jc } from 'utils';
import { PDP_REVIEWS_ADD_NEW_CLICK } from '../../actions';

export type ReviewsAddNewButtonMappedState = object;

export type ReviewsAddNewButtonProps = { wide?: boolean } & ReviewsAddNewButtonMappedState &
  React.HTMLAttributes<HTMLElement>;

export const ReviewsAddNewButton: React.FC<ReviewsAddNewButtonProps> = ({
  wide,
  className = '',
  ...htmlProps
}) => {
  const { t } = useTranslation();
  return (
    <div className={jc(className)} {...htmlProps}>
      <Button href="#reviews-form" size="l" kind="regular" variant="primary" wide={wide}>
        {t('reviews.form.ui.write-review')}
      </Button>
    </div>
  );
};

const mapStoreToProps = (): ReviewsAddNewButtonMappedState => {
  return {};
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps: React.HTMLAttributes<HTMLElement>) => {
  const onClick: React.HTMLAttributes<HTMLElement>['onClick'] = (...args) => {
    dispatch(PDP_REVIEWS_ADD_NEW_CLICK());
    return ownProps.onClick?.(...args);
  };
  return {
    onClick,
  };
};

export const PdpReviewsAddNew = connect(mapStoreToProps, mapDispatchToProps)(ReviewsAddNewButton);
